import { docReady } from '../helpers/doc-ready';
docReady(() => {
    const desktopNav = document.querySelector('store-header');
    const desktopFirstLevelDropdowns = desktopNav.querySelectorAll('.header__link-list > ul > li > details > summary');
    const desktopFirstLevelLinks = desktopNav.querySelectorAll('.header__link-list > ul > li > a');
    const desktopSecondLevelLinks = desktopNav.querySelectorAll('.header__link-list > ul > li > details > .dropdown-menu > ul > li a');
    const desktopSecondLevelMegaMenuHeadings = desktopNav.querySelectorAll('.header__link-list > ul > li > details > .mega-menu > ul > li > a');
    const desktopThirdLevelMegaMenuItems = desktopNav.querySelectorAll('.header__link-list > ul > li > details > .mega-menu > ul > li > ul > li > a');
    const desktopMegaMenuTiles = desktopNav.querySelectorAll('.header__link-list > ul > li > details > .mega-menu > .navigation-promo__wrapper > .navigation-promo > a p');
    const desktopMegaMenuCarouselTiles = desktopNav.querySelectorAll('.header__link-list > ul > li > details > .mega-menu > .navigation-promo__wrapper mega-menu-promo-carousel > a p');
    const mobileNav = document.querySelector('navigation-drawer');
    const mobileLinks = mobileNav.querySelectorAll('.panel-list__wrapper .panel__wrapper li a');
    const mobileButtons = mobileNav.querySelectorAll('.panel-list__wrapper .panel__wrapper li button');
    const mobileMegaMenuTiles = mobileNav.querySelectorAll('.panel-list__wrapper .panel__wrapper .navigation-promo a p');
    const updateLinkContent = (link) => {
        const innerHTML = link.innerHTML;
        const matches = innerHTML.match(/\[(.*?)\]/);
        if (matches) {
            const string = innerHTML.replace(/\[(.*?)\]/, '');
            const badge = '<span class="sticker">' + matches[1] + '</span>';
            link.innerHTML = string + badge;
        }
    };
    desktopFirstLevelDropdowns.forEach((link) => {
        updateLinkContent(link);
    });
    desktopFirstLevelLinks.forEach((link) => {
        updateLinkContent(link);
    });
    desktopSecondLevelLinks.forEach((link) => {
        updateLinkContent(link);
    });
    desktopSecondLevelMegaMenuHeadings.forEach((link) => {
        updateLinkContent(link);
    });
    desktopThirdLevelMegaMenuItems.forEach((link) => {
        updateLinkContent(link);
    });
    desktopMegaMenuTiles.forEach((link) => {
        updateLinkContent(link);
    });
    desktopMegaMenuCarouselTiles.forEach((link) => {
        updateLinkContent(link);
    });
    mobileLinks.forEach((link) => {
        updateLinkContent(link);
    });
    mobileButtons.forEach((link) => {
        updateLinkContent(link);
    });
    mobileMegaMenuTiles.forEach((link) => {
        updateLinkContent(link);
    });
});
